import type { FieldValues, ValidationRule } from "react-hook-form";
import { Controller } from "react-hook-form";
import NumberField from "../numberField/NumberField";
import type { FormComponentProps } from "./FormComponentProps";

interface FormNumberFieldProps<
  TFieldValues extends FieldValues = FieldValues,
> extends FormComponentProps<TFieldValues> {
  readonly suffix?: string;
  readonly margin?: "dense" | "none" | "normal";
  readonly size?: "small" | "medium";
  readonly min?: number;
  readonly max?: number;
  readonly defaultValue?: number;
  readonly rules?: {
    required?: ValidationRule<boolean>;
    min?: ValidationRule<number | string>;
    max?: ValidationRule<number | string>;
    validate?: (value: number) => boolean | string;
  };
}

function FormNumberField<TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  label,
  rules,
  suffix,
  margin,
  size,
  min,
  max,
  defaultValue,
  disabled,
}: FormNumberFieldProps<TFieldValues>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <NumberField
          helperText={error ? error.message : null}
          error={!!error}
          onChange={onChange}
          value={value ?? defaultValue}
          fullWidth
          label={label}
          suffix={suffix}
          margin={margin}
          size={size}
          min={min}
          max={max}
          disabled={disabled}
        />
      )}
    />
  );
}

export default FormNumberField;
